import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonOne } from '../../ButtonOne/ButtonOne.component';
import { AnnotationDefinitionDetails } from './AnnotationDefinitionDetails.component';

interface AddAnnotationDefinitionProps {
  onChange: () => void;
}

export const AddAnnotationDefinition: React.FC<AddAnnotationDefinitionProps> = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ButtonOne
        variant="contained"
        color="primary"
        size="small"
        style={{ height: '30px' }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <span style={{ margin: '0px 10px 0px -4px', fontSize: '20px' }}>+</span>{' '}
        {t('systemSettings:annotationDefinitionManager.addButton')}
      </ButtonOne>
      <AnnotationDefinitionDetails
        title={t('Dodaj adnotację')}
        open={open}
        onClose={handleClose}
        onSave={() => {
          handleClose();
          props.onChange();
        }}
      />
    </>
  );
};
